/* MARMOT: блог – client-side филтри по категории (бриф 17.07.2026).
   Фиксираните пет категории са в Liquid-а (marmot-blog.liquid);
   тук само превключваме видимостта на заредените карти по data-cats,
   без презареждане. Акцентната карта се вижда само на „Всички";
   пагинацията се крие при активен филтър (важи само за заредените).
   Vanilla, defer, никакви библиотеки. */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-marmot-blog]');
    if (!root) return;

    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-marmot-chip]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-marmot-card]'));
    var featured = root.querySelector('[data-marmot-featured]');
    var counter = root.querySelector('[data-marmot-count]');
    var pagination = root.querySelector('[data-marmot-pagination]');

    function apply(cat) {
      var visible = 0;
      cards.forEach(function (card) {
        var cats = ' ' + (card.getAttribute('data-cats') || '') + ' ';
        var show = !cat || cats.indexOf(' ' + cat + ' ') !== -1;
        card.hidden = !show;
        if (show) visible++;
      });
      if (featured) {
        var showFeatured = !cat;
        featured.hidden = !showFeatured;
        if (showFeatured) visible++;
      }
      if (pagination) pagination.hidden = !!cat;
      if (counter) {
        counter.textContent = visible + (visible === 1 ? ' статия' : ' статии');
      }
      chips.forEach(function (chip) {
        var active = (chip.getAttribute('data-cat') || '') === (cat || '');
        chip.classList.toggle('is-active', active);
        chip.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        apply(chip.getAttribute('data-cat') || '');
      });
    });

    apply('');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
